// removed by extract-text-webpack-plugin
module.exports = {"modalButtons":"DataBox_modalButtons__3rZy","table":"DataBox_table__3V8c","dataBox":"DataBox_dataBox__1u1T","cursor":"DataBox_cursor__BlCr","tabs":"DataBox_tabs__3N77","tab":"DataBox_tab__1mcG","tabSelected":"DataBox_tabSelected__Mt_v"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/Admin/DataBox.scss
// module id = 30
// module chunks = 0